import React from 'react';

const CheckoutSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto pt-10 p-4 lg:flex gap-8 mt-8 animate-pulse">
      {/* Form Skeleton */}
      <div className="flex-1 bg-white rounded shadow p-8 space-y-4">
        <div className="w-1/2 h-8 bg-gray-200 rounded" />
        {Array.from({ length: 7 }).map((_, i) => (
          <div key={i} className="w-full h-10 bg-gray-100 rounded" />
        ))}
        <div className="flex gap-3">
          <div className="w-1/2 h-10 bg-gray-200 rounded" />
          <div className="w-1/2 h-10 bg-gray-200 rounded" />
        </div>
        <div className="w-full h-12 bg-gray-300 rounded" />
      </div>

      {/* Summary Skeleton */}
      <div className="lg:w-1/3 bg-white rounded shadow p-8 space-y-4 h-fit">
        <div className="w-2/3 h-6 bg-gray-200 rounded" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="w-full h-16 bg-gray-100 rounded" />
        ))}
        <div className="w-full h-6 bg-gray-300 rounded" />
      </div>
    </div>
  );
};

export default CheckoutSkeleton;
